app.factory('medicalProcedureModel', ['$rootScope', 'baseModel', 'medicalProcedureService', '$q',
    function($rootScope, baseModel, medicalProcedureService, $q) {

        function MedicalProcedureModel() {

            this.getDataPage = function(criteria) {
                return medicalProcedureService.getDataPage(criteria).then(
                    function (dataPage) {
                        return dataPage;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                )
            };

            this.save = function(medicalProcedure) {
                return medicalProcedureService.save(medicalProcedure).then(
                    function (medicalProcedure) {
                        return medicalProcedure;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                )
            };

            this.update = function(medicalProcedure) {
                return medicalProcedureService.update(medicalProcedure).then(
                    function (medicalProcedure) {
                        return medicalProcedure;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                )
            };

            this.delete = function(id) {
                medicalProcedureService.delete(id).then(
                    function (medicalProcedure) {
                        return medicalProcedure;
                    },
                    function(error) {
                        return $q.reject(error);
                    }
                )
            };

        }

        return new MedicalProcedureModel();
    }
]);